import {Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField} from "@mui/material"
import {Box} from "@mui/system"
import {FC, useEffect, useState} from "react"
import {ClimbigEventType, ClimbingEvent} from "../../../../models/ClimbingEvent"
import {DifficultyCategory, UserClimbingEvent} from "../../../../models/UserClimbingEvent"
import {EditSectionDetailsComponent} from "./EditSectionDetailsComponent"
import {UpdateCompetitionData} from "./UpdateCompetitionData"
import {useTranslation} from "react-i18next";

type Props = {
  userEvent: UserClimbingEvent
  handleUpdate: (userEvent: UserClimbingEvent) => void
  event: ClimbingEvent
}
export const EditUserEventDetailsComponent: FC<Props> = ({userEvent, handleUpdate, event}) => {

  const {t} = useTranslation()
  const [newUserEvent, setNewUserEvent] = useState(userEvent)
  const [error, setError] = useState<string>()
  const [disableSave, setDisableSave] = useState(false)
  const setStartNumber = (startNumber: string) => {
    startNumber = startNumber.replace(/\D/g, '').substring(0, 3)
    setNewUserEvent({...newUserEvent, startNumber: startNumber})
  }
  useEffect(() => {
    if (!userEvent.category) {
      setNewUserEvent({...userEvent, category: DifficultyCategory.LIGHT})
    }
  }, [userEvent])

  useEffect(() => {
    if (isUndefinedOrToShort(newUserEvent.section) && newUserEvent.isSection) {
      setError(t('event.error.wrongSection') || " Error ")
    } else {
      setError(undefined)
    }
  }, [newUserEvent, t])

  const isStartNumberOk = (startNumber?: string) => {
    return startNumber && (startNumber.length === 2 || startNumber.length === 3)
  }

  useEffect(() => {
    if (!newUserEvent.category || (event.collectUserId && !isStartNumberOk(newUserEvent.startNumber)) || (!!error && newUserEvent.isSection) || (event.type !== ClimbigEventType.BOULDER && event.groups && event.groups.length > 0 && ((!newUserEvent.competitionUserData?.city && event.collectCompetitionData) || !newUserEvent.competitionUserData?.group))) {
      setDisableSave(true)
    } else {
      setDisableSave(false)
    }
  }, [newUserEvent, error, event])


  return (
    <Grid container justifyContent="center" justifyItems="center" spacing={2} alignItems="center">
      <Grid xs={6} item>
        <Box display="flex" justifyContent="end">
          {/*<FormControl fullWidth>*/}
          {/*  <InputLabel id="category-label">{t('event.user.categoryAndGroup')}</InputLabel>*/}
          {/*  <Select*/}
          {/*    sx={{minWidth: 100}}*/}
          {/*    labelId="category-label"*/}
          {/*    id="user-event-category"*/}
          {/*    value={newUserEvent.category || ""}*/}
          {/*    label={t('event.user.category')}*/}
          {/*    onChange={(e) => setNewUserEvent({...newUserEvent, category: (e.target.value as DifficultyCategory)})}*/}
          {/*  >*/}

          {/*    <MenuItem value={DifficultyCategory.LIGHT}>{t('event.categories.light')}</MenuItem>*/}
          {/*    <MenuItem value={DifficultyCategory.PRO}>{t('event.categories.pro')}</MenuItem>*/}
          {/*  </Select>*/}
          {/*</FormControl>*/}
        </Box>
      </Grid>
      {event.allowSection && <EditSectionDetailsComponent
          isSection={newUserEvent.isSection}
          handleIsSectionChange={(isSection) => setNewUserEvent({...newUserEvent, isSection})}
          section={newUserEvent.section}
          handleSectionChange={(section) => setNewUserEvent({...newUserEvent, section})}
          error={error}
      />}
      {event.type !== ClimbigEventType.BOULDER && event.groups && event.groups.length > 0 &&
          <Grid xs={12} item>
              <UpdateCompetitionData
                  collectUserData={event.collectCompetitionData}
                  groups={event.groups}
                  competitionData={newUserEvent.competitionUserData || {sponsorName: "", city: ""}}
                  handleCompetitionUpdate={(competitionUserData) => setNewUserEvent({
                    ...newUserEvent,
                    competitionUserData
                  })}/>
          </Grid>}

      {event.collectUserId && <Grid xs={12} item>
          <Box display="flex" justifyContent="center" flexDirection="column" gap="15px">
              <TextField label={t('user.climbingId')}
                         value={newUserEvent.startNumber || ""}
                         required
                         error={!isStartNumberOk(newUserEvent.startNumber)}
                         helperText={!isStartNumberOk(newUserEvent.startNumber) && t('event.error.wrongStartNumber')}
                         onChange={e => setStartNumber(e.target.value)}
              />
          </Box></Grid>}

      <Grid item xs={12}>
        <Box display="flex" justifyContent="center">
          <Button disabled={disableSave} onClick={() => handleUpdate(newUserEvent)}>{t('save')}</Button>
        </Box>
      </Grid>
    </Grid>
  )
}

const isUndefinedOrToShort = (s: string | undefined): boolean => {
  return !s || s.length < 5;
}